module.exports = __webpack_public_path__ + "static/media/live_waiting8caf082b79be970c4a1ad0d20a5d7ebe.webp";